
// $(window).on('load',function(){
//   $('head').append('<link href="//fonts.googleapis.com/css?family=Noto+Serif+JP:300,500&display=swap&subset=japanese" rel="stylesheet">');
// });

window.addEventListener('load', function(){
  deSVG('.svg', true);
});


// ios.js
var userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.indexOf('ipad') != -1) {
    $('body').addClass('ios');
}else if(userAgent.indexOf('iphone') != -1){
    $('body').addClass('ios');
}

var winWidth   = $(window).width();
var winWidthSm = 991;


$(document).ready(function() {

  // ページトップボタン
  if ($(window).scrollTop() <= 100) {
    $("#pagetop_js").hide();
  }
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $('#pagetop_js').fadeIn("slow");
    } else {
      $('#pagetop_js').fadeOut("slow");
    }
  });


  // ページ内スクロール
  $('.scroll_js:not([href=""])').on('click', function() {
    var speed = 600;
    var href  = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var headHeight = 0;

    winWidth   = $(window).width();
    if ( winWidth < winWidthSm ) {
      headHeight = $('#header').outerHeight();
    }
    var position = target.offset().top - headHeight;
    if ( href == '#' ) { position = 0; }
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });


  // drawer
  $(".drawer").drawer();
  myScroll = new IScroll('.drawer-nav', {
    mouseWheel: true,
    preventDefault: false
  });
  $(".drawer-hamburger").on('click', function() {
    myScroll.refresh();
  });
  $('.drawer_main > li > a').on('click', function() {
    $('.drawer').drawer('close');
  });


  // objectFitImages使用
  objectFitImages('img.ofi');


  // table_wrap
  if ( document.getElementById('editor_js') != null ) {
    $('#editor_js table').each(function() {
      $(this).wrap('<div class="tbl_wrap"></div>');
    });
  }



  // tab
  $('#tabbtn_js > li > a').on('click', function(){
    var clickHref = $(this).attr('href');
    $('#tabbtn_js > li > a').removeClass('active');
    $(this).addClass('active');

    $('#tab_js > div').hide();
    $(clickHref).fadeIn();

    if ( clickHref == '#opencampus' ) {
      $('#accessnav_js, #access').fadeIn();
    } else {
      $('#accessnav_js, #access').hide();
    }

    return false;
  }).eq(0).click();


  // accordion
  $('.panelaccordion_js').on('click', function(){
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active').next().stop().slideUp();
    } else {
      $(this).addClass('active').next().stop().slideDown();
    }
  });
  $('.btnaccordion_js').on('click', function(){
    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active').next().stop().slideUp();
    } else {
      $('.btnaccordion_js').each( function() {
        $(this).removeClass('active').next().stop().slideUp();
      });
      $(this).addClass('active').next().stop().slideDown();
    }
  });



  // popup
  $('.popup_js').magnificPopup({
    type:'inline',
    closeBtnInside:false,
    gallery: {
      enabled: false,
    },
    callbacks: {
      open: function(){
        $('html').css({
          'overflow': 'hidden',
          'touch-action': 'none',
        });
      },
      close: function(){
        $('html').css({
          'overflow': 'visible',
          'touch-action': 'auto',
        });
      }
    }
  });

});


// scrollBtn
function scrollBtn() {
  var viewH = $('#main').offset().top;

  var headerH = 0;
  if ( winWidth < winWidthSm ) {
    headerH = $('#header').outerHeight();
  }

  if ( $(window).scrollTop() > (viewH - headerH - 1) ) {
    $('#sidebtn_js').removeClass('scroll');
  } else {
    $('#sidebtn_js').addClass('scroll');
  }
}

$(window).on('load scroll resize', function(){
  scrollBtn();
});



// ANIMATION
$(window).on('load scroll', function() {
  var windowHeight = $(window).height(),
      topWindow    = $(window).scrollTop();

  $('.animate_js').each(function(){
    var self = $(this);
    var targetPosition = self.offset().top;
    if(winWidth > winWidthSm) {
      triggerPosition = targetPosition - windowHeight + ( windowHeight / 5 );
    } else {
      triggerPosition = targetPosition - windowHeight + ( windowHeight / 10 );
    }
    if( topWindow > triggerPosition ){
      self.addClass("scrolled");
    }
  });
});



// page loader
var cookies = getCookieArray();
console.log(cookies['loader']);
if ( cookies['loader'] ) {
  $('body').addClass('page_loaded');
} else {
  $(window).on('load', function() {
    $('#pageloader_js > .inr_conts').delay(400).fadeOut(800).parent().delay(800).fadeOut(1200, function() {
      $('body').addClass('page_loaded');
      document.cookie = "loader=1; path=/; max-age=604800000;";
    });
  });
}




// parallax
var timer = false;
var prevNum = 0;
var polkadot01 = 'translate(0, 0)';
var polkadot02 = 'translate(0, 0)';

$(window).on('load scroll', function() {
  if (timer !== false) {
    clearTimeout(timer);
  }

  timer = setTimeout(function() {
    var random = Math.floor( ( Math.random() * 9 ) + 1 );

    if ( prevNum == random && random != 9 ) {
      random = random + 1;
    } else if( prevNum == random && random == 9 ) {
      random = 1;
    }

    if ( random == 1 ) {
      polkadot01 = 'translate(-.6em, -.6em)';
      polkadot02 = 'translate(.6em, .6em)';
    } else if ( random == 2 ) {
      polkadot01 = 'translate(0, -.6em)';
      polkadot02 = 'translate(0em, .6em)';
    } else if ( random == 3 ) {
      polkadot01 = 'translate(.6em, -.6em)';
      polkadot02 = 'translate(-.6em, .6em)';
    } else if ( random == 4 ) {
      polkadot01 = 'translate(-.6em, 0em)';
      polkadot02 = 'translate(.6em, 0em)';
    } else if ( random == 5 ) {
      polkadot01 = 'translate(0em, 0em)';
      polkadot02 = 'translate(0em, 0em)';
    } else if ( random == 6 ) {
      polkadot01 = 'translate(.6em, 0em)';
      polkadot02 = 'translate(-.6em, 0em)';
    } else if ( random == 7 ) {
      polkadot01 = 'translate(-.6em, .6em)';
      polkadot02 = 'translate(.6em, -.6em)';
    } else if ( random == 8 ) {
      polkadot01 = 'translate(0em, .6em)';
      polkadot02 = 'translate(0em, -.6em)';
    } else if ( random == 9 ) {
      polkadot01 = 'translate(.6em, .6em)';
      polkadot02 = 'translate(-.6em, -.6em)';
    }

    $('#polkadot01_js').css('transform', polkadot01);
    $('#polkadot02_js').css('transform', polkadot02);

    prevNum = random;
  }, 50);
});



// cookie
function getCookieArray() {
    var arr = new Array();
    if(document.cookie != ''){
        var tmp = document.cookie.split('; ');
        for(var i=0;i<tmp.length;i++){
            var data = tmp[i].split('=');
            arr[data[0]] = decodeURIComponent(data[1]);
        }
    }
    return arr;
}





// youtube
function youtube_defer() {
  var iframes = document.querySelectorAll('.youtube_js');
  iframes.forEach(function(iframe){
    if(iframe.getAttribute('data-src')) {
      iframe.setAttribute('src',iframe.getAttribute('data-src'));
    }
  });
}
window.addEventListener('load', youtube_defer);
